import { useTranslation } from 'next-i18next'
import { TextArea } from 'modules/ui/atoms/TextArea'
import styled from '@emotion/styled'
import { Collapsible } from 'modules/ui/atoms/Collapsible'
import useOrder from 'modules/order/state/order/use-order'

const TextAreaWrapper = styled.div`
  textarea {
    max-height: 420px;
  }
`

const Comment = () => {
  const { t } = useTranslation()
  const order = useOrder()

  return (
    <Collapsible
      color="#EBEAEA"
      iconName="comment"
      label={t('CommentStep.title', 'Leave a comment')}
      dataId="comment-drawer-textarea"
    >
      <TextAreaWrapper>
        <TextArea
          tabIndex={0}
          value={order.comment.value}
          label={t('CommentStep.label', 'Your comment')}
          maxLength={500}
          hasOverflow={false} // Block input at 500 characters
          onChange={order.comment.setValue}
          dataId="comment-drawer-textarea"
          autoFocus
        />
      </TextAreaWrapper>
    </Collapsible>
  )
}

export default Comment
